import { render, staticRenderFns } from "./PaperSizeComp.vue?vue&type=template&id=2fabba04&scoped=true&"
import script from "./PaperSizeComp.vue?vue&type=script&lang=ts&"
export * from "./PaperSizeComp.vue?vue&type=script&lang=ts&"
import style0 from "./PaperSizeComp.vue?vue&type=style&index=0&id=2fabba04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabba04",
  null
  
)

export default component.exports